

















































import { Component, Vue, PropSync, Emit, Prop } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "ResetPasswordModal",
  components: {
    AgroIcons,
  },
})
export default class ResetPasswordModal extends Vue {
  @PropSync("open", { type: Boolean, default: false })
  private stateSynced!: boolean;

  @Prop({ type: String, default: "" }) private response!: string;

  private userInfo: string = "";

  public resetPassword() {
    this.$emit("onsubmit", this.userInfo);
    this.userInfo = "";
  }

   @Emit("oncancel")
  public closeResetPassword() {
    this.userInfo = "";
  }
}
